// src/models/landing-page.js
import eventservice from "@/services/events/eventservice";

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class Event {
  constructor({
    id = null,
    bookingTresholds = null,
    organisation = null,
    singleRoomAvailable = false,
    sports = null,
    courses = null,
    startDate = null,
    name = null,
    instructors = null,
    departureLocations= null,
  } = {}) {
    this.id = id;
    this.courses = courses;
    this.instructors = instructors;
    this.departureLocations = departureLocations
    this.bookingTresholds = bookingTresholds;
    this.name = name;
    this.organisation = organisation;
    this.singleRoomAvailable = singleRoomAvailable;
    this.sports = sports;
    this.startDate = startDate;
  }
}

export class EventBookingInfo {
  constructor({
    bookingStatus = null,
    bookingStatusIcon = "",
    bookingStatusText = "",
    currentBookings = 0,
    currentBusBookings = 0,
    freeSeats = 0,
    maxBooking = 0,
    openRequest = 0,
  } = {}) {
    this.bookingStatus = bookingStatus;
    this.bookingStatusIcon = bookingStatusIcon;

    this.bookingStatusText = bookingStatusText;
    this.currentBookings = currentBookings;
    this.currentBusBookings = currentBusBookings;
    this.freeSeats = freeSeats;
    this.maxBooking = maxBooking;
    this.openRequest = openRequest
  }
}

export class BookingTresholds {
  constructor({
    redStatus = 0,
    yellowStatus = 0,
    waitingListSeats = 0,
  } = {}) {
    this.redStatus = redStatus;
    this.yellowStatus = yellowStatus;
    this.waitingListSeats = waitingListSeats;
  }
}

export class EventDetailsInfo {
  constructor({ event = null, eventBookingInfo = null, sports = null,  departureLocations = null, courses = null, volunteerAssignments=null} = {}) {
    this.event = event;
    this.eventBookingInfo = eventBookingInfo;
    this.sports = sports;
    this.departureLocations = departureLocations
    this.courses = courses,
    this.volunteerAssignments = volunteerAssignments
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseDetailsAdapter(response) {
  let bookingTresholds = new BookingTresholds({
    ...response.data.event.bookingTresholds,
  });
  let event = new Event({ ...response.data.event, bookingTresholds });
  let eventBookingInfo = new EventBookingInfo({
    ...response.data.eventBookingInfo,
  });
  let sports = response.data.sports;
  let courses = response.data.courses;
  let departureLocations = response.data.departureLocations;
  let volunteerAssignments = response.data.volunteerAssignments

  let out = new EventDetailsInfo({ event, eventBookingInfo, sports, departureLocations, courses, volunteerAssignments });
  return out
}

export function responseAdapter(response) {
  return response.data;
}

//function mapAndAdd(out, element){
//  out.push(new Event({ ...element }));
//}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getAll() {
    return responseAdapter(await eventservice.getAll());
  },
  async getDetails(eventId) {
    return responseDetailsAdapter(await eventservice.getDetails(eventId));
  },
  async update(eventId, event) {
    return responseAdapter(await eventservice.update(eventId, event));
  },
  async addInstructor(eventId, instructor) {
    return responseAdapter(await eventservice.addInstructor(eventId, instructor));
  },
  async updateInstructorCourseAssignment(eventId, instructorCourseAssignment) {
    return responseDetailsAdapter(await eventservice.updateInstructorCourseAssignment(eventId, instructorCourseAssignment));
  },
  async removeInstructor(eventId, instructor) {
    return responseAdapter(await eventservice.removeInstructor(eventId, instructor));
  },
  async updateVolunteerAssignment(eventId, volunteerId, request) {
    return responseAdapter(await eventservice.updateVolunteerAssignment(eventId, volunteerId, request));
  },
};
